import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  data: {
    sectionIndex: '',
    name: '',
    description: '',
  },
  openForm: false,
  error: null,
  status: null,
}

const slice = createSlice({
  name: 'dynamicTableAddColumn',
  initialState,
  reducers: {
    changeName: (state, action) => {
      state.data.name = action.payload.name
    },
    changeDescription: (state, action) => {
      state.data.description = action.payload.description
    },
    openForm: (state, action) => {
      state.data.sectionIndex = action.payload.sectionIndex
      state.openForm = true
    },
    closeForm: (state) => {
      state.data.sectionIndex = ''
      state.data.name = ''
      state.data.description = ''
      state.openForm = false
    },
    resetForm: () => initialState,
    changeRequestStatus: (state, action) => {
      state.status = action.payload.status
    },
  },
})

const selectSlice = (state) => state.dynamicTableAddColumn
export const selectFormData = (state) => selectSlice(state).data
export const selectError = (state) => selectSlice(state).error
export const selectRequestStatus = (state) => selectSlice(state).status
export const selectOpenForm = (state) => selectSlice(state).openForm

const { reducer, actions } = slice

export const { changeRequestStatus, resetForm, changeDescription, changeName, openForm, closeForm } = actions

export default reducer
